import React, { useEffect, useContext, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../component/context/AuthContext';
import axios from 'axios';
import * as CONST from '../../component/config/Constant';
import { toast } from 'react-toastify';
import { decrypt } from './Helper';

const QuizAutoStart = () => {
    const { setId: encryptedId } = useParams();
    const setId = decrypt(encryptedId);
    const navigate = useNavigate();
    const location = useLocation();
    const [authUserData] = useContext(AuthContext);
    const [loading, setLoading] = useState(true);

    const user = authUserData && authUserData[0] ? authUserData[0] : null;
    const token = user ? user.token : '';
    const userId = user ? (user.id || user.user_id) : null;

    useEffect(() => {
        const handleAutoStart = async () => {
            // 1. Check if logged in
            if (!user || !token) {
                // Redirect to Role Selection instead of direct login
                navigate(`/guest-quiz-login/${encryptedId}`);
                return;
            }

            // 2. User is logged in, ensure the test is assigned
            try {
                setLoading(true);
                const payload = {
                    user_id: userId,
                    question_set_id: setId
                };

                const resp = await axios.post(CONST.ISO_ASSIGN_TEST, payload, {
                    headers: { Authorization: `Basic ${token}` }
                });

                // Even if it's already assigned (status: error), we still want to redirect
                // The backend returns "error" if already assigned, which is fine for us.

                // 3. Redirect to Quiz Manager with start flag
                navigate(`${CONST.ADMIN_PRE}user-quiz?startSet=${encryptedId}`);
            } catch (err) {
                console.error("Auto-start error:", err);
                toast.error("Failed to initialize quiz. Please try manually.");
                navigate(`${CONST.ADMIN_PRE}user-quiz`);
            } finally {
                setLoading(false);
            }
        };

        handleAutoStart();
    }, [setId, user, token, userId, navigate, location.pathname]);

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
            <div className="text-center">
                <div className="spinner-border text-primary mb-3" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <h4>Initializing your assessment...</h4>
                <p className="text-muted">Please wait while we set things up for you.</p>
            </div>
        </div>
    );
};

export default QuizAutoStart;
